import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { IUser } from '../models/users.model';

const routes = {
  users: () => `/v1/user-management/search`
};

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  public users$ = new BehaviorSubject<IUser[]>([]);

  constructor(private http: HttpClient) { }

  getUsers(Filter?: string, SkipCount?: number, TakeCount?: number): Observable<IUser[]> {
    SkipCount = SkipCount ?? 0;
    TakeCount = TakeCount ?? 50;
    let params: any = Filter ? { Filter } : { isOrderByDescending: false, orderField: 'fullName' };
    params = { ...params, SkipCount };
    params = { ...params, TakeCount };
    return this.http.get<IUser[]>(routes.users(), { params }).pipe(
      map((res) => res.sort((a, b) => a.fullName.localeCompare(b.fullName)))
    );
  }

  setUsers(user: IUser[]) {
    this.users$.next(user);
  }
}
